import React, { Component } from 'react';
import CobiGraph from './cobiGraph';
import CobiInputParameters from './inputViews/cobiInputParameters';

class OdeGraphMain extends Component {
  render() {
    //var bg=require("../images/cfdrcBlue.jpg");
    return (
      <div style={styles.Mainbody2}  >
        <div style={styles.LeftSideBar}>
          <div style={styles.Legend} >
            <CobiInputParameters/>
          </div>
        </div>
        <div style={styles.TimeLineView} >
            <CobiGraph/>
        </div>
        {/**<div style={styles.RightSideBar}>
          <div style={styles.Legend}>parameter list</div>
        </div>**/}

      </div>
      );
    }
  }

  export default (OdeGraphMain)
  const styles = {
    Mainbody2: {
    	height: '750',
      width: '100%',
    	//overflow: 'auto',
      backgroundColor:'transparent',

    },
    RightSideBar: {
      width:'20%',
    	height:'100%',
    	backgroundColor:'black',
    	float: 'right',
    	//alignItems: 'stretch',
    	overflow: 'visible',
    	textAlign:'center',
    	display: 'flex',
    	flexDirection: 'column',
    },

    LeftSideBar: {
    	width:'20%',
    	height:'100%',
    	backgroundColor: '#132F57',
    	float: 'left',
    	//alignItems: 'flex-start',

    	overflow: 'visible',
    	//textAlign:'right',
    	//display: 'flex',
    	//flexDirection: 'column',
    },

    TimeLineView: {
    	width: '80%',
    	height:'100%',
    	backgroundColor:'transparent',
    	float:'left',
    	alignItems: 'stretch',
    	overflow: 'hidden',
    	//box-shadow: inset 0 0 5px black,
    },
    Legend: {
    	borderBottom:'black',
    	backgroundColor: 'transparent',
      color:'white',
      height:'100%',
    }
}



// WEBPACK FOOTER //
// ./src/components/odeGraphMain.js